import React from 'react';
import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { testTypeAPI } from '../redux/test-types.slice';

export function useTestType(id?: string | null) {
  const { entity: testType } = useEntityIdSelector(testTypeAPI, id);
  return React.useMemo(() => ({ testType }), [testType]);
}
